import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { useDispatch } from 'react-redux';

import { ajaxRequestCompleted, ajaxRequestInitiated, siteManagement } from '../../../../redux/actions';

const DATA = [
	{
		id: 'PARTSNET',
		displayName: 'PartsNet',
		files: [
			{
				id: 'ACCESSORIES_CATALOG',
				displayName: 'Accessories Catalog',
				acceptedFiles: ['.pdf'],
				fileNameRegex: /^Accessories Catalog \d{4}\.pdf$/,
				message: 'File name should be Accessories Catalog <year>, example: Accessories Catalog 2025.pdf',
				s3Path: 'CustomerNet/PartsNet/PartsCatalog/',
				queryParam: 'CatlogFile'
			},
			{
				id: 'FREIGHT',
				displayName: 'Freight Document',
				acceptedFiles: ['.pdf'],
				// fileNameRegex: /^PARTS-[\w\d]{3,}\.pdf$/,
				message: 'File name should match the subclass, example: PARTS-AWB.pdf',
				s3Path: 'CustomerNet/PartsNet/DiscountDocs/',
				queryParam: 'DiscountDocument'
			},
			{
				id: 'MULTI_PACK',
				displayName: 'Multi Pack File',
				acceptedFiles: ['.xlsx'],
				s3Path: 'CustomerNet/PartsNet/multiPackFiles/',
				queryParam: 'MultiPackFile'
			},
			{
				id: 'PRICING_FILE',
				displayName: 'Pricing File',
				acceptedFiles: ['.txt'],
				s3Path: 'pricing-reports-txt/',
				queryParam: 'PricingFile'
			},
			{
				id: 'WEIGHT_AND_DIMENSIONS',
				displayName: 'Weight and Dimensions File',
				acceptedFiles: ['.xlsx'],
				s3Path: 'CustomerNet/PartsNet/weightAndDimensionsFiles/',
				queryParam: 'WeightAndDimensionsFile'
			}
		]
	}
];

const INITIAL_FIELDS = {
	application: DATA[0],
	fileCategory: null,
	fileName: '',
	file: null
};

const INITIAL_ERRORS = {
	application: false,
	fileCategory: false,
	fileName: false,
	file: false
};

const FileUploads = () => {
	const [previewURL, setPriviewURL] = useState(null);
	const [fields, setFields] = useState(INITIAL_FIELDS);
	const [errors, setErrors] = useState(INITIAL_ERRORS);
	const [status, setStatus] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {
		setPriviewURL(fields.file ? URL.createObjectURL(fields.file) : fields.file);
	}, [fields.file]);

	const handleChange = e => {
		const fieldName = e.target.name;
		const fieldValue = fieldName === 'file' ? e.target.files && e.target.files[0] : e.target.value;

		setFields(fields => {
			const newFields = { ...fields };

			switch (fieldName) {
				case 'application':
					newFields.application = DATA.find(application => application.id === fieldValue);
					break;
				case 'fileCategory':
					newFields.fileCategory = fields.application.files.find(file => file.id === fieldValue);
					newFields.file = null;
					break;
				case 'fileName':
				case 'file':
					newFields[fieldName] = fieldValue;
			}

			return newFields;
		});
		if (errors[fieldName] && isFieldValid(fieldName, fieldValue)) {
			setErrors(errors => ({ ...errors, [fieldName]: false }));
		}
		if (['application', 'fileCategory'].includes(fieldName) && errors.file) {
			setErrors(errors => ({ ...errors, file: false }));
		}
		setStatus(null);
	};

	const isFieldValid = (fieldName, fieldValue) => {
		if (['fileCategory'].includes(fieldName)) {
			return !!fieldValue;
		}
		if (fieldName === 'file') {
			if (fieldValue) {
				switch (fields.fileCategory.id) {
					case 'ACCESSORIES_CATALOG':
						return fields.fileCategory.fileNameRegex.test(fieldValue.name);
					default:
						return true;
				}
			}
			return false;
		}
		return true;
	};

	const isFormInvalid = () => {
		let isFormError = false;
		for (const fieldName in fields) {
			if (!isFieldValid(fieldName, fields[fieldName])) {
				setErrors(errors => ({ ...errors, [fieldName]: true }));
				isFormError = true;
			}
		}
		return isFormError;
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (status) {
			setStatus(null);
		}
		if (isFormInvalid()) {
			return;
		}

		dispatch(
			siteManagement(
				{
					docName: fields.file.name,
					type: fields.file.type
				},
				`requestType=getUploadURL&fileType=${fields.fileCategory.queryParam}`,
				true,
				uploadURLResponse => {
					const uploadURL = uploadURLResponse.responseObject && uploadURLResponse.responseObject['Upload Url'];
					if (uploadURL) {
						dispatch(ajaxRequestInitiated());
						fetch(uploadURL, {
							method: 'PUT',
							body: new Blob([fields.file], {
								type: fields.file.type
							})
						})
							.then(res => {
								setStatus('S');
								setFields(INITIAL_FIELDS);
								setErrors(INITIAL_ERRORS);
							})
							.catch(() => {
								setStatus('E');
							})
							.finally(() => {
								dispatch(ajaxRequestCompleted());
							});
					} else {
						setStatus('E');
					}
				}
			)
		);
	};

	return (
		<div className="fileUpload">
			<div className="push">
				<h1 className="pageTitle">FILE UPLOADS</h1>
			</div>
			<form onSubmit={handleSubmit}>
				<div className="fileUploadFormContentWrapper push">
					<div>
						<div className="fileUploadFormRow">
							<label htmlFor="application">
								<b>Application</b>
							</label>
							<select name="application" id="application" value={fields.application.id} onChange={handleChange}>
								{DATA.map(application => (
									<option key={application.id} value={application.id}>
										{application.displayName}
									</option>
								))}
							</select>
						</div>
						{fields.application && (
							<div className="fileUploadFormRow">
								<label htmlFor="fileCategory">
									<b>Type</b>
								</label>
								<select
									name="fileCategory"
									id="fileCategory"
									className={errors.fileCategory ? 'error' : undefined}
									value={fields.fileCategory ? fields.fileCategory.id : ''}
									onChange={handleChange}
								>
									<option value="" disabled>
										Please Select
									</option>
									{fields.application.files.map(file => (
										<option key={file.id} value={file.id}>
											{file.displayName}
										</option>
									))}
								</select>
							</div>
						)}
					</div>
					<div className={errors.file ? 'red' : undefined}>
						{fields.file && (
							<div style={{ marginBottom: '1rem' }}>
								{fields.file.type.includes('video/') ? (
									<video src={previewURL} controls style={{ width: '100%' }} />
								) : (
									<a href={previewURL} target="_blank">
										{fields.file.name}
									</a>
								)}
							</div>
						)}
						{!!fields.fileCategory && (
							<div className="fileUploadButtonWrapper">
								<input id="file" name="file" type="file" accept={fields.fileCategory.acceptedFiles.join(', ')} onChange={handleChange} />
								<label htmlFor="file" style={errors.file ? { borderColor: 'red' } : undefined}>
									Choose File
									{fields.fileCategory.acceptedFiles && fields.fileCategory.acceptedFiles.length ? ` (${fields.fileCategory.acceptedFiles.join(', ')})` : ''}
								</label>
							</div>
						)}
						{fields.fileCategory && fields.fileCategory.message && (
							<p className="small bold text-center" style={{ margin: '.25rem 0 0' }}>
								<em>{fields.fileCategory.message}</em>
							</p>
						)}
					</div>
				</div>
				{status && <p className={`bold text-right${status === 'E' ? ' red' : ''}`}>{status === 'S' ? 'File uploaded successfully' : 'File upload failed'}</p>}
				<p className="flex items-center justify-between">
					<Link to="/siteManagement">Back to Site Management</Link>
					<button className="fileUploadSubmitButton">Submit</button>
				</p>
			</form>
		</div>
	);
};

export default FileUploads;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/FileUploads/index.jsx